export default __webpack_public_path__ + "static/media/fairy-muppet.62e2e96f.png";